
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library/events-list",
      function () {
        return require("private-next-pages/library/events-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library/events-list"])
      });
    }
  